<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Bank Account</el-button>
            <el-button @click="toBillingExRate">Billing Exchange Rate</el-button>
            <el-button @click="alipayConfig">Alipay Config</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-input v-model="dataForm.keyword" clearable placeholder="Bank Name / Account Number" class="wd300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.billingCurrency" filterable clearable placeholder="Currency">
                <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column label="Supplier" prop="supplier.abbr" align="center" min-width="100" />
        <el-table-column label="Tag / Label" prop="tag" align="center" min-width="100" />
        <el-table-column label="Bank Name" prop="bankName" align="center" min-width="100" />
        <el-table-column label="Account Number" prop="accountNumber" align="center" min-width="150" />
        <el-table-column label="Swift Code" prop="swiftCode" align="center" min-width="100" />
        <el-table-column label="Currency" prop="billingCurrency" align="center" min-width="100" />
        <el-table-column label="Create Time" prop="createTime" align="center" width="160" sortable="custom" />
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" :supplierList="supplierList" :bankAccountList="bankAccountList" @refreshDataList="refreshDataList" />
    <!-- 支付宝配置 = 弹窗 -->
    <alipay-modal ref="alipayModal" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import AlipayModal from "./modal/Alipay";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapState } from "vuex";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    AddOrUpdateDialog,
    AlipayModal,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataForm: {
        keyword: "",
        supplierId: "",
        billingCurrency: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      supplierList: [],
      bankAccountList: [],
      addBtnLoading: false,
      dataListLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            if (res.code === 200) {
              this.supplierList = res.data || [];
              resolve();
            } else {
              this.$message.error(res.msg);
              reject();
            }
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取银行账户列表
    getBankAccountList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplierBankAccount")
          .then(res => {
            if (res.code === 200) {
              this.bankAccountList = res.data || [];
              resolve();
            } else {
              this.$message.error(res.msg);
              reject();
            }
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/supplierBankAccount/page", {
        params: params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this bank account. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(
        `/admin/supplierBankAccount/batchDelete`,
        {},
        {
          params: {
            "ids[]": row.id,
          },
        },
      );
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getBankAccountList();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 设置开票汇率
    toBillingExRate() {
      this.$router.push("/sys/other/bankAccount/billingExRate");
    },
    // 支付宝配置
    alipayConfig() {
      this.$refs.alipayModal.init();
    },
    // 弹窗组件触发更新
    refreshDataList() {
      this.getBankAccountList();
      this.getDataList();
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
      await this.getBankAccountList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped>
.printWrap {
  .search-mian {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .search-item {
    height: 40px;
    display: flex;
    align-items: center;
    .searchSelect {
      ::v-deep .el-input__inner {
        border-right: 0px;
      }
    }
  }
  .pagination {
    height: auto;
  }
}
</style>
